
import apiWorker from '../apiWorker'

const flagged = {
    search    : (data)        => apiWorker('post', `/v1/admin/flagged/search`, data),
    approve   : (document_id) => apiWorker('post', `/v1/admin/flagged/${document_id}/approve`),
    reject    : (document_id) => apiWorker('post', `/v1/admin/flagged/${document_id}/reject`),
}

export default flagged;